import { useEffect, useState } from "react";
import { ChainBootstrap } from "./components/ChainBootstrap";
import { ChainGraph } from "./components/ChainGraph";
import { Header } from "./components/Header";
import { Landing } from "./components/Landing";
import { SignaturesPanel } from "./components/SignaturesPanel";
import { SystemPanel } from "./components/SystemPanel";
import { AccessControl } from "./pages/AccessControl";
import { AccessDenied } from "./pages/AccessDenied";
import { ClaimOwner } from "./pages/ClaimOwner";
import { OwnerSetup } from "./pages/OwnerSetup";
import {
  useAccessRevoked,
  useAuth,
  usePendingOwnerClaim,
} from "./hooks/useAuth";

function useHashRoute() {
  const [hash, setHash] = useState(() => window.location.hash);
  useEffect(() => {
    const onChange = () => setHash(window.location.hash);
    window.addEventListener("hashchange", onChange);
    return () => window.removeEventListener("hashchange", onChange);
  }, []);
  return hash;
}

export default function App() {
  const auth = useAuth();
  const pendingClaim = usePendingOwnerClaim();
  const accessRevoked = useAccessRevoked();
  const hash = useHashRoute();

  if (auth.isLoading || pendingClaim.isLoading) return null;

  if (hash === "#/access-denied" || accessRevoked.data === true) {
    return <AccessDenied />;
  }

  if (pendingClaim.data === true || hash === "#/claim-owner") {
    return <ClaimOwner />;
  }

  if (auth.isError || auth.data == null) return <Landing />;

  if (auth.data.needs_owner_setup || hash === "#/owner-setup") {
    return <OwnerSetup />;
  }

  if (hash.startsWith("#/admin/access") && auth.data.is_server_owner) {
    return (
      <div className="app">
        <Header />
        <AccessControl />
      </div>
    );
  }

  return (
    <div className="app">
      <Header />
      <ChainBootstrap />
      <main className="graph-wrap">
        <ChainGraph />
        <SystemPanel />
        <SignaturesPanel />
      </main>
    </div>
  );
}
